import React from "react";
import HeaderTop from "./HeaderTop";
import { useState } from "react";
import { useEffect } from "react";
import api from "../utils/ApiMethod";
import Menu from "./Menu";
import { background, border } from "@chakra-ui/react";
import Styled from "../pages/NewinfoButton/NewInfoButton.module.css";
import NewInfoButton from "../pages/NewinfoButton/NewInfoButton";

const Header = () => {
  const [navData, setNavData] = useState({});
  const [navSlogan, setNavSlogan] = useState();
  const [fullSlogan, setFullSlogan] = useState([]);
  const [isScrolled, setIsScrolled] = useState(false);

  const handleFetchData = async () => {
    try {
      const data = await api.fetchData("/header");
      setNavData(data[0]);
      setNavSlogan(data[0].slogan);
      if (data[0].slogan.split(" ").length > 2) {
        setFullSlogan(data[0].slogan.split(" "));
      } else {
        setNavSlogan(data[0].slogan);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    handleFetchData();
  }, []);

  const handleScroll = () => {
    if (window.scrollY > 0) {
      setIsScrolled(true);
    } else {
      setIsScrolled(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <HeaderTop />
      {/* <Navbar /> */}

      <div className={`sticky_header  ${isScrolled ? "scrolled" : ""}`}>
        <div className="header" style={{ border: "" }}>
          <div className="siteheader">
            <div className={`${Styled.ghghgh}`}>
              {/* FLASH HIDDEN */}
              {/* <NewInfoButton /> */}
            </div>

            <div className="container">
              <div className="row">
                <div className="col-lg-5 col-md-5 col-sm-7">
                  <a href="/" className="sitelogo">
                    {/* <img src="./img/bssalogo73.png" alt="bssa-logo" /> */}
                    <img src="/img/bssalogo73.png" alt="bssa-logo" />
                    <h1 className="mb-0 mt-5" style={{ color: "#016938", marginBottom: "0px", marginTop: "14px" }}>
                      {fullSlogan.length > 0 ? fullSlogan[0] : navSlogan}
                      <span style={{ color: "#f05623" }}>
                        {" "}
                        {fullSlogan.length > 1 ? fullSlogan[1] : ""}{" "}
                        {fullSlogan.length > 2 ? fullSlogan[2] : ""}
                      </span>{" "}
                      {fullSlogan.length >= 3 ? fullSlogan[3] : ""}
                      <small style={{ color: "#016938", fontweight: "600" }}>
                        {navData.state}
                      </small>
                    </h1>
                  </a>
                </div>

                <div className="col-lg-7 col-md-7 col-sm-5">
                  <div
                    className="location__naveen"
                    style={{
                      display: "flex",

                      // gap: "1px",
                    }}
                  >
                    <div
                      className="location__link"
                    // style={{ border: "2px solid blue" }}
                    >
                      {/* <div
                        style={{
                          position: "relative",
                          width: "100%",
                        }}
                      >
                        <a
                          href="https://online.bih.nic.in/GADREC/(S(uciq31wvsnuj5h0syzxylfsp))/Default.aspx"
                          target="_blank"
                          rel="noreferrer"
                          className="bg-headcont payplay__link"
                          style={{
                            width: "100%",
                            // height: "50px",
                            paddingRight: "55%",
                            alignItems: "center",
                          }}
                        >
                          <img
                            src="img/play-logo.png"
                            alt="pay & play logo"
                            className="payplay_img"
                          />
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                            }}
                          >
                            <span
                              className="play"
                              style={{ fontWeight: "bold" }}
                            >
                              मेडल लाओ
                            </span>

                            <span className="logo__title">
                              {" "}
                              <h6 style={{ fontSize: "16px", color: "blue" }}>
                                नौकरी पाओ
                              </h6>
                            </span>
                          </div>
                        </a>
                      </div> */}
                    </div>
                    {/* hide CM name with image due to code of conduct */}
                    <div>
                      <div className="cmProfile">
                        <div className="cmProfile__textarea">
                          <h4 className="cmProfile__text">
                            {navData?.profileName}
                          </h4>
                          <small className="">{navData?.designation}</small>
                        </div>
                        <div className="cmProfile__img">
                          <img src="/img/cm-samrat-1.png" alt="cm-image" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Menu />
      </div>
    </>
  );
};
export default Header;
